import React from 'react';
import { ApplicationState } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';

type Props = {
    onConfirm: () => void
}

const RejectAllDialog: React.FC<Props> = ({ onConfirm }) => {

    const open = useSelector((app: ApplicationState) => app.comp.rejectAllDialogOpen);
    const dispatch = useDispatch();
    const contextMenuSubTree = useSelector((app: ApplicationState) => app.comp.rejectAllDialogSubtree);

    const onCancel = () => {
        dispatch({ type: ComponentManagementActionType.REJECT_ALL_DIALOG_OPEN, open: false })
    }

    const onRejectAll = () => {
        dispatch({ type: ComponentManagementActionType.REJECT_ALL_DIALOG_OPEN, open: false })
        onConfirm()
    }

    return (
        <Dialog maxWidth='sm' fullWidth={true} open={open} onClose={() => { }}>
            <DialogTitle disableTypography={true}>
                <Typography variant='h4'>Reject All</Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant='h4'>
                    Are you sure you want to reject this Provision (
                    {contextMenuSubTree?.citation ??
                        contextMenuSubTree?.heading}
                    ) and its associated children?
                </Typography>
                <Typography>
                    This will revert all impacted provisions and editorial
                    content to the last approved version and delete any new
                    provisions.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' color='primary' onClick={onRejectAll}>Yes</Button>
                <Button size='small' variant='outlined' color='secondary' onClick={onCancel}>No</Button>
            </DialogActions>
        </Dialog>
    );
}

export default RejectAllDialog;
